export default "__VITE_ASSET__CYU6QI5i__"